import React from "react";
import { Layers } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

// Category translations
const CAT_TRANSLATIONS = {
  "Performans": { en: "Performance", es: "Rendimiento", de: "Performance", fr: "Performance", ar: "الأداء" },
  "SEO": { en: "SEO", es: "SEO", de: "SEO", fr: "SEO", ar: "سيو" },
  "Sosyal Medya": { en: "Social Media", es: "Redes Sociales", de: "Social Media", fr: "Réseaux Sociaux", ar: "التواصل الاجتماعي" },
  "Kreatif": { en: "Creative", es: "Creativo", de: "Kreativ", fr: "Créatif", ar: "إبداعي" },
  "Strateji": { en: "Strategy", es: "Estrategia", de: "Strategie", fr: "Stratégie", ar: "الاستراتيجية" },
  "Marka": { en: "Brand", es: "Marca", de: "Marke", fr: "Marque", ar: "العلامة التجارية" },
  "Analitik": { en: "Analytics", es: "Analítica", de: "Analytik", fr: "Analytique", ar: "التحليلات" },
  "CRM": { en: "CRM", es: "CRM", de: "CRM", fr: "CRM", ar: "CRM" },
  "E-Ticaret": { en: "E-Commerce", es: "E-Commerce", de: "E-Commerce", fr: "E-Commerce", ar: "التجارة الإلكترونية" },
  "Yapay Zeka": { en: "AI & Automation", es: "IA & Automatización", de: "KI & Automatisierung", fr: "IA & Automatisation", ar: "الذكاء الاصطناعي" },
};

const FILTER_ALL = { tr: "Tümü", en: "All", es: "Todo", de: "Alle", fr: "Tout", ar: "الكل" };
const FILTER_LABEL = { tr: "Kategori", en: "Category", es: "Categoría", de: "Kategorie", fr: "Catégorie", ar: "الفئة" };

const PRESET = ["Performans", "SEO", "Sosyal Medya", "Kreatif", "Strateji", "Marka", "Analitik", "CRM", "E-Ticaret", "Yapay Zeka"];

export default function BlogCategoryChips({ active, onChange, dynamicCategories = [] }) {
  const { lang } = useLanguage();
  const merged = Array.from(new Set([...PRESET, ...dynamicCategories]));

  const getLabel = (cat) => {
    if (lang === "tr") return cat;
    return CAT_TRANSLATIONS[cat]?.[lang] || cat;
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="blog-category-chips">
      <span className="inline-flex items-center gap-1.5 text-[0.65rem] uppercase tracking-[0.18em] font-bold text-ink/55 me-2">
        <Layers className="h-3 w-3" />
        {FILTER_LABEL[lang] || FILTER_LABEL.en}
      </span>
      <button type="button" onClick={() => onChange("")}
        data-testid="blog-chip-all"
        className={`rounded-full px-4 py-1.5 text-xs font-semibold transition-colors
          ${!active ? "bg-brand-pink text-cream" : "bg-cream border border-mist text-ink/65 hover:border-brand-pink"}`}>
        {FILTER_ALL[lang] || FILTER_ALL.en}
      </button>
      {merged.map((c) => {
        const slug = c.toLowerCase().replace(/\s+/g, "-");
        return (
          <button key={c} type="button" onClick={() => onChange(c)}
            data-testid={`blog-chip-${slug}`}
            className={`rounded-full px-4 py-1.5 text-xs font-semibold transition-colors
              ${active === c ? "bg-brand-pink text-cream" : "bg-cream border border-mist text-ink/65 hover:border-brand-pink"}`}>
            {getLabel(c)}
          </button>
        );
      })}
    </div>
  );
}
